export const HEADERS_TITLE = {
  XSRF: 'X-XSRF-TOKEN'
}
